/* eslint-disable react/prop-types */

function CardGroup1(props) {
  const { fillColor } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="320" height="480" viewBox="0 0 320 480">
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_177"
            data-name="Rectangle 177"
            width="320"
            height="480"
            fill="none"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
        <filter
          id="Path_3270"
          x="115.359"
          y="158.744"
          width="244.057"
          height="293.055"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur" />
          <feFlood floodColor="#161615" floodOpacity="0.439" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_3326"
          x="94.3"
          y="140.327"
          width="214.928"
          height="280.983"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur-2" />
          <feFlood floodColor="#161615" floodOpacity="0.439" />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_3382"
          x="-39.416"
          y="158.744"
          width="244.057"
          height="293.055"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur-3" />
          <feFlood floodColor="#161615" floodOpacity="0.439" />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_3438"
          x="10.771"
          y="140.327"
          width="214.928"
          height="280.983"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur-4" />
          <feFlood floodColor="#161615" floodOpacity="0.439" />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_3494"
          x="61.5"
          y="124.31"
          width="197"
          height="287"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur-5" />
          <feFlood floodColor="#161615" floodOpacity="0.439" />
          <feComposite operator="in" in2="blur-5" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Mask_Group_1" data-name="Mask Group 1" clipPath="url(#clipPath)">
        <g id="BKG">
          <rect
            id="Rectangle_176"
            data-name="Rectangle 176"
            width="320"
            height="480"
            fill="none"
            opacity="0"
          />
          <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3270)">
            <path
              id="Path_3270-2"
              data-name="Path 3270"
              d="M350.713,236.521c3.888-10.681-1.7-22.613-16-26.4L217.76,167.553c-7.141-4.015-19.093,1.532-22.981,12.213L124.1,373.969a20.766,20.766,0,0,0,12.424,26.515l116.95,42.566a20.765,20.765,0,0,0,26.56-12.326Z"
              fill="#fff"
            />
          </g>
          <g id="Group_229" data-name="Group 229">
            <path
              id="Path_3271"
              data-name="Path 3271"
              d="M170,386.837l.011.024-.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3272"
              data-name="Path 3272"
              d="M186.026,342.816h0l.011.024-.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3273"
              data-name="Path 3273"
              d="M181.1,356.363l.011.024-.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3274"
              data-name="Path 3274"
              d="M165.073,400.384l.011.024-.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3275"
              data-name="Path 3275"
              d="M202.048,298.795h0l.011.024-.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3276"
              data-name="Path 3276"
              d="M197.118,312.342l.011.024-.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3277"
              data-name="Path 3277"
              d="M218.071,254.774h0l.011.024-.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3278"
              data-name="Path 3278"
              d="M213.14,268.321l.011.024-.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3279"
              data-name="Path 3279"
              d="M161.08,308.743l1.863-5.119,30.781-14.287L179.331,258.6l1.86-5.112,17.674,37.721Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3280"
              data-name="Path 3280"
              d="M164.81,298.493l1.86-5.112,16.777-7.786L175.6,268.849l1.864-5.122,11.121,23.74Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3281"
              data-name="Path 3281"
              d="M168.534,288.262l1.867-5.128,2.759-1.282-1.287-2.762,1.864-5.122,4.569,9.756Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3282"
              data-name="Path 3282"
              d="M204.012,293.082l-44.8,20.789-.391,1.077,20.957,44.714L225.3,338.538l.005,0-21.29-45.453Zm-7.457,20.489-1.64-3.5,3.5-1.621,3.275,6.989-10.509,4.882-6.546-13.991,17.511-8.131,18.015,38.464-17.51,8.121L196.1,330.811l10.512-4.874,3.276,6.988-3.508,1.628-1.63-3.5-3.509,1.629,3.278,6.981,10.507-4.869-6.55-13.98-31.516,14.62,6.547,13.987,10.5-4.871-3.266-7-3.507,1.623,1.64,3.508-3.506,1.62-3.28-7,10.516-4.869,6.549,13.991-17.512,8.118-18.015-38.455,17.5-8.13,6.549,13.983-7,3.261-3.5,1.618-3.286-6.994L177.4,318.2l1.642,3.5,3.505-1.626-1.643-3.49-1.64-3.506-10.51,4.878,4.919,10.484,1.642,3.5,31.516-14.625-6.553-13.981-10.5,4.87,3.272,7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3283"
              data-name="Path 3283"
              d="M136.847,375.324l1.863-5.12,30.781-14.287L155.1,325.179l1.86-5.112,17.674,37.721Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3284"
              data-name="Path 3284"
              d="M140.577,365.074l1.86-5.112,16.777-7.786-7.847-16.748,1.864-5.123,11.121,23.74Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3285"
              data-name="Path 3285"
              d="M144.3,354.842l1.866-5.128,2.759-1.282-1.287-2.762,1.864-5.122,4.569,9.756Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3286"
              data-name="Path 3286"
              d="M265.685,315.533l-18.018-38.456-38.522,17.878,18.018,38.455Zm-19.879-33.344,14.738,31.473-31.517,14.629-14.743-31.467Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3287"
              data-name="Path 3287"
              d="M255.4,311.791,243.94,287.317,219.422,298.7l11.472,24.465Zm-13.33-19.352,8.192,17.483-17.513,8.126-8.193-17.483Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3288"
              data-name="Path 3288"
              d="M245.126,308.05l-4.914-10.491-10.51,4.877,4.916,10.493Zm-6.777-5.372,1.63,3.5-3.5,1.624-1.635-3.492Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3289"
              data-name="Path 3289"
              d="M155.034,379.658l1.64,3.5,1.642,3.491-3.5,1.627-1.642-3.5-3.507,1.626,3.212,6.835-5.144-1.872-3.206-6.834Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3290"
              data-name="Path 3290"
              d="M190.792,401.375l-6.849,3.174-5.373-1.956-1.564-3.331,3.508-1.628,1.63,3.5,3.508-1.628-3.276-6.987-10.512,4.874,1.562,3.33-10.038-3.653,20.853-9.672Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3291"
              data-name="Path 3291"
              d="M201.069,405.116l-.006,0-6.837,3.173-5.141-1.871,6.846-3.175-18.016-38.464-17.51,8.13,6.546,13.991,10.509-4.881-3.275-6.99-3.5,1.621,1.639,3.5-3.505,1.629-3.273-7,10.505-4.871,6.553,13.981-24.356,11.3-5.137-1.87,3.342-1.545,7-3.261L156.9,374.538l-17.5,8.13,3.2,6.831-1.834-.667a8.4,8.4,0,0,1-5.387-8.563l44.406-20.607Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3292"
              data-name="Path 3292"
              d="M246.6,383.987l44.758-20.771.408-1.121-20.933-44.688h0L225.3,338.535l-.005,0Zm7.457-20.487,1.639,3.508-3.506,1.62-3.28-7,10.517-4.869,6.548,13.991-17.511,8.118-18.016-38.455,17.5-8.129,6.549,13.982-7,3.261-3.5,1.618-3.286-6.994,3.507-1.625,1.642,3.5,3.505-1.626-1.642-3.49-1.64-3.506-10.51,4.878,4.918,10.484,1.643,3.5,31.516-14.626L267.1,327.657l-10.505,4.87,3.272,7,3.506-1.629-1.639-3.5,3.5-1.621,3.275,6.99L258,344.648l-6.546-13.991,17.51-8.131,18.015,38.464-17.51,8.122-6.555-13.976,10.512-4.874,3.276,6.988-3.508,1.628-1.63-3.5-3.509,1.629,3.278,6.981,10.508-4.869-6.55-13.98-31.517,14.619,6.547,13.988,10.5-4.871-3.266-7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3293"
              data-name="Path 3293"
              d="M241.452,382.113l-18.019-38.455-38.521,17.877L202.93,399.99Zm-19.879-33.344,14.738,31.473-31.518,14.629L190.05,363.4Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3294"
              data-name="Path 3294"
              d="M231.172,378.372,219.706,353.9l-24.517,11.378,11.472,24.465Zm-13.33-19.353,8.192,17.483-17.513,8.127-8.194-17.484Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3295"
              data-name="Path 3295"
              d="M220.892,374.63l-4.913-10.491-10.511,4.878,4.917,10.492Zm-6.777-5.371,1.63,3.5-3.494,1.624-1.636-3.491Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3296"
              data-name="Path 3296"
              d="M313.725,301.756l-1.86,5.112L281.1,321.15l14.387,30.707-1.863,5.119-17.662-37.7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3297"
              data-name="Path 3297"
              d="M310,311.995l-1.864,5.122L291.38,324.89l7.838,16.724-1.86,5.112L286.242,323.02Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3298"
              data-name="Path 3298"
              d="M306.271,322.237l-1.864,5.122-2.739,1.276,1.28,2.732-1.866,5.128-4.56-9.733Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3299"
              data-name="Path 3299"
              d="M201.069,405.116,246.6,383.987l20.751,44.3a8.4,8.4,0,0,1-9.639,3.109l-1.8-.655,6.84-3.172-18.015-38.465-17.51,8.131,6.546,13.991,10.508-4.881L241,399.357l-3.5,1.621,1.64,3.5-3.506,1.629-3.272-7,10.5-4.871,6.553,13.981-24.349,11.3-5.138-1.87,3.337-1.542,7-3.261-6.549-13.982-17.5,8.13,3.2,6.826-5.148-1.874-3.2-6.826Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3300"
              data-name="Path 3300"
              d="M257.612,425.7l-6.843,3.171-5.381-1.959-1.561-3.325,3.508-1.628,1.63,3.5,3.509-1.628-3.276-6.987-10.512,4.874,1.559,3.324-10.029-3.65,20.847-9.67Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3301"
              data-name="Path 3301"
              d="M221.853,403.983l1.64,3.5,1.642,3.491-3.5,1.626-1.642-3.5-3.507,1.625,3.209,6.83-5.144-1.872-3.2-6.828Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3302"
              data-name="Path 3302"
              d="M185.313,242.163l1.863-5.119,30.781-14.287-14.393-30.738,1.86-5.112L223.1,224.628Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3303"
              data-name="Path 3303"
              d="M189.044,231.913l1.86-5.112,16.777-7.786-7.847-16.748,1.864-5.123,11.121,23.74Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3304"
              data-name="Path 3304"
              d="M192.768,221.682l1.867-5.128,2.758-1.282-1.287-2.762,1.864-5.122,4.569,9.757Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3305"
              data-name="Path 3305"
              d="M228.245,226.5l-44.8,20.79-.392,1.076,20.957,44.715h0l45.518-21.124.006,0L228.245,226.5h0Zm-7.457,20.49-1.639-3.5,3.5-1.621,3.275,6.99-10.509,4.881-6.545-13.99,17.51-8.131L244.4,270.085l-17.51,8.121-6.555-13.975,10.512-4.874,3.276,6.988-3.508,1.628-1.63-3.5-3.509,1.629,3.279,6.981,10.506-4.869-6.549-13.98-31.517,14.619,6.547,13.988,10.5-4.871-3.266-7-3.506,1.623,1.639,3.508-3.506,1.62-3.28-7,10.517-4.87,6.549,13.992-17.512,8.118L187.86,249.507l17.5-8.13,6.549,13.983-7,3.261-3.5,1.618-3.286-6.994,3.507-1.625,1.642,3.5,3.505-1.626L205.141,250,203.5,246.5l-10.511,4.878,4.92,10.484,1.641,3.5,31.516-14.625-6.552-13.981-10.505,4.87,3.272,7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3306"
              data-name="Path 3306"
              d="M204.012,293.082h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3307"
              data-name="Path 3307"
              d="M289.918,248.953,271.9,210.5l-38.522,17.877L251.4,266.83Zm-19.879-33.344,14.738,31.473L253.26,261.711l-14.743-31.467Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3308"
              data-name="Path 3308"
              d="M279.638,245.211l-11.465-24.474-24.518,11.378,11.472,24.465Zm-13.329-19.352,8.191,17.482-17.512,8.127-8.194-17.483Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3309"
              data-name="Path 3309"
              d="M269.359,241.47l-4.914-10.491-10.51,4.877,4.916,10.493Zm-6.777-5.372,1.63,3.5-3.495,1.624-1.635-3.492Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3310"
              data-name="Path 3310"
              d="M270.831,317.407l44.758-20.771.408-1.121-20.932-44.688h0l-45.529,21.129-.006,0,21.3,45.449h0Zm7.457-20.487,1.639,3.508-3.505,1.62-3.281-7,10.517-4.869,6.549,13.991L272.7,312.287l-18.016-38.455,17.5-8.13,6.55,13.983-7,3.261-3.5,1.618-3.286-6.994,3.508-1.626,1.642,3.5,3.505-1.626-1.643-3.491-1.64-3.505L259.81,275.7l4.919,10.484,1.642,3.5,31.516-14.625-6.553-13.981-10.5,4.87,3.271,7,3.506-1.629-1.639-3.5,3.5-1.621,3.276,6.99-10.509,4.882-6.546-13.991,17.51-8.131,18.015,38.464-17.51,8.122-6.555-13.976,10.512-4.874,3.276,6.988-3.508,1.628-1.63-3.5-3.508,1.628,3.278,6.982,10.507-4.869-6.55-13.98-31.517,14.619,6.547,13.988,10.5-4.871-3.266-7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3311"
              data-name="Path 3311"
              d="M270.831,317.407h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3312"
              data-name="Path 3312"
              d="M337.959,235.175l-1.86,5.112-30.762,14.282,14.387,30.706-1.863,5.12L300.2,252.7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3313"
              data-name="Path 3313"
              d="M334.232,245.415l-1.864,5.122-16.755,7.773,7.838,16.724-1.86,5.112L310.475,256.44Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3314"
              data-name="Path 3314"
              d="M330.5,255.657l-1.864,5.122-2.739,1.276,1.28,2.732-1.867,5.128-4.56-9.733Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3315"
              data-name="Path 3315"
              d="M217.1,179.092l1.824.664-6.829,3.171,18.016,38.455,17.512-8.118-6.549-13.992-10.517,4.87,3.281,7,3.505-1.62-1.639-3.508,3.506-1.623,3.266,7-10.5,4.871-6.547-13.988,24.343-11.291,5.142,1.872-10.345,4.8,6.555,13.975,17.51-8.121-3.193-6.819,5.138,1.87,3.194,6.819-.006,0L228.245,226.5h0l-20.772-44.319A8.406,8.406,0,0,1,217.1,179.092Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3316"
              data-name="Path 3316"
              d="M222.143,195.278l-4.919-10.484,6.832-3.17,5.4,1.964,1.564,3.324-3.5,1.627-1.642-3.5-3.507,1.626,3.286,6.994,3.5-1.619,7-3.261-1.555-3.321,10.029,3.65-20.835,9.669Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3317"
              data-name="Path 3317"
              d="M252.985,206.5l-3.278-6.982,3.509-1.628,1.63,3.5,3.508-1.628-3.2-6.821,5.141,1.871,3.2,6.82Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3318"
              data-name="Path 3318"
              d="M228.245,226.5h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3319"
              data-name="Path 3319"
              d="M319.8,230.829l-3.278-6.982,3.508-1.628,1.63,3.5,3.508-1.628-3.2-6.826,5.141,1.871,3.2,6.825Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3320"
              data-name="Path 3320"
              d="M295.065,250.826h0l-21.3-45.448.006,0,6.831-3.17,5.147,1.873-6.834,3.174,18.015,38.455,17.512-8.118L307.891,223.6l-10.517,4.869,3.281,7,3.505-1.62-1.639-3.508,3.507-1.623,3.265,7-10.5,4.871L292.244,226.6,316.593,215.3l5.142,1.872-10.35,4.8,6.554,13.976,17.511-8.122-3.2-6.825,1.8.654a8.4,8.4,0,0,1,5.386,8.576l-44.37,20.592Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3321"
              data-name="Path 3321"
              d="M288.962,219.6l-4.919-10.484,6.837-3.173,5.389,1.961,1.567,3.33-3.5,1.627-1.642-3.5-3.507,1.626,3.286,6.994,3.5-1.618,7-3.261-1.558-3.326,10.037,3.653L290.6,223.1Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3322"
              data-name="Path 3322"
              d="M295.065,250.827h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3323"
              data-name="Path 3323"
              d="M289.492,368.336l-1.86,5.112L256.87,387.73l14.387,30.707-1.863,5.119-17.662-37.7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3324"
              data-name="Path 3324"
              d="M285.765,378.575,283.9,383.7l-16.754,7.773,7.838,16.724-1.861,5.112L262.008,389.6Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3325"
              data-name="Path 3325"
              d="M282.038,388.817l-1.864,5.122-2.739,1.276,1.28,2.732-1.867,5.128-4.56-9.733Z"
              fill={fillColor || '#8ea5ab'}
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3326)">
            <path
              id="Path_3326-2"
              data-name="Path 3326"
              d="M301.42,193.216c1.974-11.194-5.6-21.974-20.345-23.222L158.51,148.382c-7.729-2.713-18.536,4.825-20.51,16.019L102.113,367.927a20.765,20.765,0,0,0,16.838,23.955l122.566,21.612a20.766,20.766,0,0,0,24.016-16.751Z"
              fill="#fff"
            />
          </g>
          <g id="Group_230" data-name="Group 230">
            <path
              id="Path_3327"
              data-name="Path 3327"
              d="M149.558,372.628l.015.021-.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3328"
              data-name="Path 3328"
              d="M157.693,326.493h0l.015.021-.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3329"
              data-name="Path 3329"
              d="M155.19,340.691l.015.021-.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3330"
              data-name="Path 3330"
              d="M147.055,386.825l.015.021-.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3331"
              data-name="Path 3331"
              d="M165.828,280.359h0l.015.021-.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3332"
              data-name="Path 3332"
              d="M163.324,294.556l.015.021-.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3333"
              data-name="Path 3333"
              d="M173.962,234.224h0l.015.022-.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3334"
              data-name="Path 3334"
              d="M171.459,248.422l.015.021-.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3335"
              data-name="Path 3335"
              d="M127.209,297.27l.946-5.365,27.833-19.415-19.512-27.772.945-5.357,23.956,34.079Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3336"
              data-name="Path 3336"
              d="M129.1,286.528l.945-5.357,15.17-10.581L134.581,255.46l.947-5.368L150.6,271.54Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3337"
              data-name="Path 3337"
              d="M130.994,275.806l.948-5.375,2.494-1.742-1.747-2.5.946-5.368,6.194,8.815Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3338"
              data-name="Path 3338"
              d="M166.769,274.391l-40.508,28.254-.2,1.128,28.4,40.395,41.158-28.707.005,0L166.77,274.391h0Zm-3.786,21.474-2.222-3.161,3.168-2.205,4.439,6.315-9.5,6.632L149.991,290.8l15.832-11.048,24.421,34.751L174.41,325.547l-8.882-12.625,9.506-6.625,4.44,6.312-3.172,2.213-2.213-3.162-3.173,2.212,4.441,6.307,9.5-6.62-8.878-12.63-28.5,19.87,8.877,12.638,9.5-6.621-4.432-6.325-3.171,2.207,2.223,3.17-3.171,2.2-4.446-6.325,9.511-6.621,8.879,12.641L155.412,338.8l-24.419-34.742,15.826-11.047,8.878,12.633-6.324,4.427-3.168,2.2-4.45-6.317,3.171-2.21,2.225,3.162,3.169-2.211-2.223-3.152-2.224-3.167-9.5,6.629,6.665,9.47,2.225,3.161,28.5-19.876-8.881-12.63-9.5,6.62,4.438,6.324Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3339"
              data-name="Path 3339"
              d="M114.905,367.047l.946-5.365,27.833-19.415-19.512-27.772.945-5.357,23.956,34.079Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3340"
              data-name="Path 3340"
              d="M116.8,356.305l.945-5.357,15.17-10.581-10.636-15.13.947-5.369L138.3,341.317Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3341"
              data-name="Path 3341"
              d="M118.69,345.582l.948-5.374,2.494-1.742-1.747-2.5.946-5.368,6.194,8.815Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3342"
              data-name="Path 3342"
              d="M231.4,285.792,206.982,251.05,172.15,275.345l24.422,34.742Zm-25.367-29.385,19.979,28.435-28.5,19.88-19.983-28.428Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3343"
              data-name="Path 3343"
              d="M220.631,283.893l-15.542-22.112L182.92,277.243l15.546,22.1Zm-16.488-16.744,11.1,15.8-15.835,11.044-11.106-15.8Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3344"
              data-name="Path 3344"
              d="M209.857,281.993l-6.66-9.479-9.5,6.629,6.664,9.479Zm-7.606-4.113,2.213,3.162-3.16,2.206-2.217-3.154Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3345"
              data-name="Path 3345"
              d="M133.569,368.157l2.224,3.167,2.223,3.152-3.169,2.21-2.225-3.162-3.172,2.21,4.35,6.174-5.391-.951-4.344-6.173Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3346"
              data-name="Path 3346"
              d="M172.555,383.335l-6.193,4.315-5.631-.993-2.119-3.009,3.173-2.212L164,384.6l3.172-2.213-4.439-6.312-9.506,6.625,2.116,3.008-10.52-1.855,18.856-13.146Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3347"
              data-name="Path 3347"
              d="M183.326,385.235l-.005,0-6.183,4.313-5.388-.95,6.191-4.316L153.52,349.534l-15.833,11.048,8.876,12.641,9.5-6.632-4.439-6.315-3.168,2.2,2.222,3.161-3.17,2.213-4.438-6.324,9.5-6.62,8.881,12.63L139.43,382.9l-5.384-.95,3.023-2.1,6.324-4.427-8.877-12.632-15.827,11.046,4.338,6.171-1.922-.339a8.4,8.4,0,0,1-6.792-7.5l40.153-28.006Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3348"
              data-name="Path 3348"
              d="M224.494,356.521l40.471-28.228.207-1.174L236.8,286.744h0l-41.169,28.714-.005,0Zm3.786-21.471,2.223,3.17-3.171,2.2-4.446-6.325,9.511-6.621,8.879,12.642L225.44,351.155l-24.419-34.742,15.826-11.046L225.725,318l-6.324,4.426-3.168,2.2-4.45-6.318,3.171-2.209,2.225,3.161,3.17-2.21-2.224-3.152-2.224-3.168-9.5,6.629,6.664,9.471,2.225,3.161,28.5-19.876L234.9,297.486l-9.5,6.621,4.438,6.323,3.169-2.213-2.222-3.161,3.168-2.2,4.44,6.315-9.5,6.631-8.876-12.641,15.833-11.048,24.42,34.751L244.438,337.9l-8.882-12.624,9.506-6.626,4.44,6.313-3.172,2.212-2.213-3.162-3.173,2.213,4.441,6.306,9.5-6.62-8.878-12.63-28.5,19.87,8.876,12.639,9.5-6.621-4.432-6.326Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3349"
              data-name="Path 3349"
              d="M219.1,355.569l-24.422-34.742-34.832,24.294,24.422,34.743Zm-25.366-29.385,19.978,28.435-28.5,19.879-19.983-28.427Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3350"
              data-name="Path 3350"
              d="M208.327,353.67l-15.541-22.112-22.17,15.462,15.546,22.1Zm-16.488-16.744,11.1,15.794-15.835,11.045L176,347.97Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3351"
              data-name="Path 3351"
              d="M197.554,351.77l-6.661-9.479-9.5,6.629,6.663,9.479Zm-7.607-4.113,2.213,3.162L189,353.025l-2.217-3.154Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3352"
              data-name="Path 3352"
              d="M276.322,263.882l-.945,5.357-27.815,19.407,19.5,27.742-.946,5.365L242.178,287.7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3353"
              data-name="Path 3353"
              d="M274.43,274.613l-.947,5.368-15.15,10.564,10.623,15.109-.945,5.357L252.948,289.6Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3354"
              data-name="Path 3354"
              d="M272.537,285.347l-.946,5.368-2.476,1.732,1.735,2.468-.948,5.374-6.181-8.793Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3355"
              data-name="Path 3355"
              d="M183.326,385.235l41.168-28.714,28.129,40.026a8.406,8.406,0,0,1-8.953,4.735l-1.886-.333,6.185-4.311-24.421-34.752-15.832,11.048,8.876,12.641,9.5-6.631-4.439-6.316-3.168,2.205,2.222,3.161-3.17,2.213-4.437-6.323,9.5-6.621,8.881,12.631L209.464,395.25l-5.385-.949,3.018-2.1,6.324-4.426-8.877-12.633L188.717,386.19l4.335,6.167-5.4-.952-4.336-6.167Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3356"
              data-name="Path 3356"
              d="M242.584,395.688,236.4,400l-5.64-.994-2.115-3,3.172-2.213,2.213,3.162,3.172-2.213-4.44-6.312-9.506,6.626,2.113,3L214.855,396.2l18.851-13.143Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3357"
              data-name="Path 3357"
              d="M203.6,380.51l2.224,3.167,2.224,3.153-3.169,2.21-2.225-3.161-3.172,2.21,4.346,6.169-5.391-.951-4.34-6.168Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3358"
              data-name="Path 3358"
              d="M139.513,227.494l.946-5.365,27.833-19.415-19.512-27.772.945-5.357,23.956,34.079Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3359"
              data-name="Path 3359"
              d="M141.407,216.752l.945-5.357,15.17-10.581-10.636-15.131.947-5.369,15.075,21.449Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3360"
              data-name="Path 3360"
              d="M143.3,206.029l.948-5.374,2.494-1.741-1.747-2.5.946-5.368,6.194,8.815Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3361"
              data-name="Path 3361"
              d="M179.073,204.615l-40.508,28.253-.2,1.128,28.4,40.395h0l41.158-28.706.005,0-28.86-41.066Zm-3.786,21.473-2.222-3.161,3.168-2.205,4.439,6.316-9.5,6.631-8.876-12.641,15.833-11.048,24.421,34.752L186.714,255.77l-8.883-12.624,9.507-6.626,4.439,6.312-3.172,2.213-2.213-3.162L183.22,244.1l4.441,6.306,9.5-6.62-8.878-12.63-28.5,19.87,8.877,12.639,9.5-6.621-4.432-6.326-3.171,2.207,2.224,3.17-3.171,2.2-4.446-6.325,9.511-6.621,8.879,12.642-15.836,11.035L143.3,234.284l15.827-11.046L168,235.871l-6.324,4.426-3.167,2.2-4.451-6.317,3.172-2.21,2.225,3.161,3.169-2.21L160.4,231.77l-2.224-3.166-9.5,6.628,6.665,9.47,2.225,3.162,28.5-19.876-8.881-12.631-9.5,6.621,4.437,6.323Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3362"
              data-name="Path 3362"
              d="M166.769,274.391h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3363"
              data-name="Path 3363"
              d="M243.707,216.016l-24.422-34.743-34.832,24.295,24.422,34.742ZM218.341,186.63l19.979,28.436-28.5,19.879-19.983-28.428Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3364"
              data-name="Path 3364"
              d="M232.934,214.116,217.393,192l-22.169,15.463,15.545,22.1Zm-16.488-16.744,11.1,15.8-15.835,11.044-11.105-15.795Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3365"
              data-name="Path 3365"
              d="M222.161,212.216l-6.661-9.478-9.5,6.628,6.663,9.48Zm-7.607-4.113,2.213,3.162-3.159,2.206-2.217-3.154Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3366"
              data-name="Path 3366"
              d="M236.8,286.744l40.47-28.227.207-1.175L249.1,216.967h0l-41.168,28.714-.005,0,28.87,41.059Zm3.786-21.471,2.223,3.171-3.171,2.2-4.446-6.326L244.7,257.7l8.879,12.642-15.836,11.035-24.42-34.742,15.827-11.046,8.877,12.633-6.323,4.426-3.168,2.2-4.451-6.317,3.172-2.21,2.225,3.162,3.169-2.211-2.223-3.152-2.224-3.167-9.5,6.629,6.665,9.47,2.225,3.161,28.5-19.876-8.881-12.63-9.5,6.62,4.437,6.324,3.17-2.214-2.222-3.16,3.168-2.205,4.439,6.315-9.5,6.632-8.876-12.642,15.832-11.047,24.421,34.751-15.834,11.039L247.86,255.5l9.506-6.625,4.439,6.312-3.172,2.212-2.213-3.162-3.172,2.213,4.441,6.306,9.5-6.62-8.878-12.63-28.5,19.87,8.877,12.639,9.5-6.621-4.431-6.326Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3367"
              data-name="Path 3367"
              d="M236.8,286.744h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3368"
              data-name="Path 3368"
              d="M288.626,194.105l-.945,5.357L259.866,218.87l19.5,27.742-.946,5.365-23.94-34.056Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3369"
              data-name="Path 3369"
              d="M286.734,204.836l-.947,5.368-15.15,10.564,10.623,15.109-.945,5.357-15.064-21.415Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3370"
              data-name="Path 3370"
              d="M284.841,215.57l-.946,5.368-2.476,1.732,1.735,2.468-.948,5.374-6.181-8.793Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3371"
              data-name="Path 3371"
              d="M159.863,159.861l1.911.337-6.174,4.309,24.419,34.742,15.836-11.035-8.879-12.642-9.511,6.621,4.446,6.325,3.171-2.2-2.223-3.169,3.171-2.208,4.432,6.326-9.5,6.621-8.877-12.639L194.1,165.9l5.389.951-9.355,6.52,8.882,12.624,15.834-11.038-4.329-6.161,5.385.949,4.329,6.162,0,0-41.158,28.707h0l-28.152-40.039A8.4,8.4,0,0,1,159.863,159.861Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3372"
              data-name="Path 3372"
              d="M167.641,174.926l-6.665-9.47,6.177-4.308,5.656,1,2.117,3-3.169,2.21-2.225-3.161-3.172,2.21,4.451,6.317,3.167-2.2,6.324-4.426-2.108-3,10.51,1.853-18.84,13.14Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3373"
              data-name="Path 3373"
              d="M199.964,180.625l-4.441-6.306,3.173-2.213,2.213,3.162,3.172-2.213-4.334-6.162,5.388.95,4.331,6.161Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3374"
              data-name="Path 3374"
              d="M179.073,204.615h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3375"
              data-name="Path 3375"
              d="M269.992,192.978l-4.441-6.306,3.172-2.213,2.213,3.162,3.172-2.213-4.338-6.167,5.388.95,4.335,6.166Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3376"
              data-name="Path 3376"
              d="M249.1,216.967h0l-28.87-41.059,0,0,6.177-4.309,5.394.951-6.179,4.313L250.047,211.6l15.836-11.036L257,187.925l-9.511,6.621,4.446,6.325,3.171-2.2-2.223-3.17,3.171-2.207,4.432,6.325-9.5,6.621L242.117,193.6l22.017-15.351,5.389.951-9.36,6.523,8.882,12.625,15.834-11.039-4.333-6.166,1.882.332a8.4,8.4,0,0,1,6.794,7.511L249.1,216.967Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3377"
              data-name="Path 3377"
              d="M237.669,187.278,231,177.808l6.182-4.312,5.647,1,2.121,3.007-3.169,2.21-2.225-3.162-3.172,2.21,4.451,6.317,3.168-2.2,6.324-4.426-2.112-3.005,10.519,1.855L239.894,190.44Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3378"
              data-name="Path 3378"
              d="M249.1,216.967h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3379"
              data-name="Path 3379"
              d="M264.019,333.659l-.945,5.357-27.815,19.407,19.5,27.742-.946,5.365-23.94-34.056Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3380"
              data-name="Path 3380"
              d="M262.126,344.39l-.947,5.368-15.15,10.564,10.623,15.109-.945,5.357-15.064-21.415Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3381"
              data-name="Path 3381"
              d="M260.234,355.124l-.946,5.368-2.476,1.732,1.735,2.468-.948,5.374-6.181-8.793Z"
              fill={fillColor || '#8ea5ab'}
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3382)">
            <path
              id="Path_3382-2"
              data-name="Path 3382"
              d="M-30.713,236.521c-3.888-10.681,1.7-22.613,16-26.4l116.95-42.566c7.141-4.015,19.093,1.532,22.98,12.213l70.685,194.2a20.766,20.766,0,0,1-12.424,26.515L66.531,443.05a20.765,20.765,0,0,1-26.56-12.326Z"
              fill="#fff"
            />
          </g>
          <g id="Group_231" data-name="Group 231">
            <path
              id="Path_3383"
              data-name="Path 3383"
              d="M150,386.837l-.011.024.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3384"
              data-name="Path 3384"
              d="M133.974,342.816h0l-.011.024.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3385"
              data-name="Path 3385"
              d="M138.9,356.363l-.011.024.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3386"
              data-name="Path 3386"
              d="M154.927,400.384l-.011.024.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3387"
              data-name="Path 3387"
              d="M117.951,298.795h0l-.011.024.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3388"
              data-name="Path 3388"
              d="M122.882,312.342l-.011.024.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3389"
              data-name="Path 3389"
              d="M101.929,254.774h0l-.011.024.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3390"
              data-name="Path 3390"
              d="M106.86,268.321l-.011.024.024.011Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3391"
              data-name="Path 3391"
              d="M158.92,308.743l-1.863-5.119-30.781-14.287L140.669,258.6l-1.86-5.112-17.674,37.721Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3392"
              data-name="Path 3392"
              d="M155.189,298.493l-1.86-5.112L136.552,285.6l7.847-16.748-1.864-5.122-11.121,23.74Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3393"
              data-name="Path 3393"
              d="M151.465,288.262l-1.867-5.128-2.759-1.282,1.287-2.762-1.864-5.122-4.569,9.756Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3394"
              data-name="Path 3394"
              d="M115.988,293.082h0L94.7,338.535l.006,0,45.518,21.124,20.957-44.714-.392-1.077-44.8-20.789ZM126.951,315.2l3.272-7-10.5-4.87-6.553,13.981,31.516,14.625,1.642-3.5,4.919-10.484-10.511-4.878-1.64,3.506-1.642,3.49,3.505,1.626,1.642-3.5,3.507,1.625-3.286,6.994-3.5-1.618-7-3.261,6.549-13.983,17.5,8.13-18.016,38.455-17.512-8.118,6.549-13.991,10.517,4.869-3.28,7-3.506-1.62,1.639-3.508-3.506-1.623-3.266,7,10.5,4.871,6.547-13.987-31.517-14.62-6.549,13.98,10.506,4.869,3.279-6.981-3.509-1.629-1.63,3.5-3.508-1.628,3.276-6.988,10.512,4.874-6.555,13.975-17.51-8.121L117.851,298.2l17.51,8.131-6.545,13.991-10.509-4.882,3.275-6.989,3.5,1.621-1.639,3.5Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3395"
              data-name="Path 3395"
              d="M183.153,375.324l-1.863-5.12-30.781-14.287L164.9,325.179l-1.86-5.112-17.674,37.721Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3396"
              data-name="Path 3396"
              d="M179.423,365.074l-1.86-5.112-16.777-7.786,7.847-16.748-1.864-5.123-11.121,23.74Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3397"
              data-name="Path 3397"
              d="M175.7,354.842l-1.866-5.128-2.759-1.282,1.287-2.762-1.864-5.122-4.569,9.756Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3398"
              data-name="Path 3398"
              d="M92.837,333.41l18.018-38.455L72.333,277.077,54.315,315.533Zm12.879-36.586L90.973,328.291,59.456,313.662l14.738-31.473Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3399"
              data-name="Path 3399"
              d="M89.106,323.16,100.578,298.7,76.06,287.317,64.6,311.791Zm6.333-22.6-8.194,17.483-17.512-8.126,8.191-17.483Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3400"
              data-name="Path 3400"
              d="M85.382,312.929,90.3,302.436l-10.51-4.877L74.874,308.05Zm-.231-8.62L83.516,307.8l-3.495-1.624,1.63-3.5Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3401"
              data-name="Path 3401"
              d="M164.966,379.658l-1.64,3.5-1.642,3.491,3.5,1.627,1.642-3.5,3.507,1.626-3.212,6.835,5.144-1.872,3.206-6.834Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3402"
              data-name="Path 3402"
              d="M129.208,401.375l6.849,3.174,5.373-1.956,1.564-3.331-3.508-1.628-1.63,3.5-3.508-1.628,3.276-6.987,10.512,4.874-1.562,3.33,10.038-3.653L135.758,387.4Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3403"
              data-name="Path 3403"
              d="M118.931,405.116l0,0,6.838,3.173,5.141-1.871-6.846-3.175,18.015-38.464,17.511,8.13L153.049,386.9l-10.509-4.881,3.275-6.99,3.5,1.621-1.639,3.5,3.505,1.629,3.272-7-10.5-4.871L137.4,383.893l24.355,11.3,5.138-1.87-3.342-1.545-7-3.261,6.549-13.982,17.5,8.13-3.2,6.831,1.834-.667a8.4,8.4,0,0,0,5.387-8.563l-44.406-20.607Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3404"
              data-name="Path 3404"
              d="M94.7,338.538l-.006,0L49.169,317.407h0L28.236,362.1l.408,1.121L73.4,383.987ZM62.439,361.877l-3.266,7,10.5,4.871,6.547-13.988L44.705,345.14l-6.55,13.98,10.507,4.869,3.279-6.981-3.509-1.629-1.63,3.5-3.508-1.628,3.276-6.988,10.512,4.874-6.555,13.976-17.51-8.122,18.015-38.464,17.51,8.131L62,344.648l-10.509-4.881,3.276-6.99,3.5,1.621-1.639,3.5,3.506,1.629,3.272-7L52.9,327.657l-6.553,13.981,31.516,14.626,1.642-3.5,4.919-10.484L73.913,337.4l-1.64,3.506-1.642,3.49,3.5,1.626,1.643-3.5,3.507,1.625L76,351.144l-3.5-1.618-7-3.261,6.549-13.982,17.5,8.129L71.538,378.867l-17.512-8.118,6.549-13.991,10.517,4.869-3.281,7-3.5-1.62,1.639-3.508Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3405"
              data-name="Path 3405"
              d="M117.07,399.99l18.018-38.455L96.567,343.658,78.548,382.113ZM129.95,363.4l-14.744,31.466L83.689,380.242l14.738-31.473Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3406"
              data-name="Path 3406"
              d="M113.339,389.74l11.472-24.465L100.293,353.9,88.828,378.372Zm6.333-22.6-8.193,17.484L93.966,376.5l8.192-17.483Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3407"
              data-name="Path 3407"
              d="M109.615,379.509l4.916-10.492-10.51-4.878L99.108,374.63Zm-.231-8.619-1.635,3.491-3.5-1.624,1.631-3.5Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3408"
              data-name="Path 3408"
              d="M6.275,301.756l1.86,5.112L38.9,321.15,24.51,351.856l1.863,5.119,17.662-37.7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3409"
              data-name="Path 3409"
              d="M10,311.995l1.864,5.122L28.62,324.89l-7.838,16.724,1.86,5.112L33.758,323.02Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3410"
              data-name="Path 3410"
              d="M13.729,322.237l1.864,5.122,2.739,1.276-1.28,2.732,1.866,5.128,4.56-9.733Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3411"
              data-name="Path 3411"
              d="M118.931,405.116,73.4,383.987l-20.752,44.3a8.406,8.406,0,0,0,9.64,3.109l1.8-.655-6.84-3.172,18.015-38.465,17.51,8.131-6.546,13.991-10.508-4.881L79,399.357l3.5,1.621-1.639,3.5,3.506,1.629,3.272-7-10.5-4.871L70.58,408.218l24.349,11.3,5.138-1.87-3.337-1.542-7-3.261,6.549-13.982,17.5,8.13-3.2,6.826,5.148-1.874,3.2-6.826Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3412"
              data-name="Path 3412"
              d="M62.388,425.7l6.843,3.171,5.381-1.959,1.561-3.325-3.508-1.628-1.63,3.5-3.509-1.628,3.276-6.987,10.512,4.874-1.559,3.324,10.029-3.65-20.847-9.67Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3413"
              data-name="Path 3413"
              d="M98.146,403.983l-1.64,3.5-1.642,3.491,3.5,1.626,1.642-3.5,3.507,1.625-3.209,6.83,5.144-1.872,3.2-6.828Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3414"
              data-name="Path 3414"
              d="M134.687,242.163l-1.863-5.119-30.781-14.287,14.393-30.738-1.86-5.112L96.9,224.628Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3415"
              data-name="Path 3415"
              d="M130.956,231.913,129.1,226.8l-16.777-7.786,7.847-16.748-1.864-5.123-11.121,23.74Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3416"
              data-name="Path 3416"
              d="M127.232,221.682l-1.866-5.128-2.758-1.282,1.287-2.762-1.864-5.122-4.569,9.757Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3417"
              data-name="Path 3417"
              d="M91.755,226.5h0l-21.29,45.453.006,0,45.518,21.124h0l20.957-44.715-.392-1.076-44.8-20.79Zm10.963,22.118,3.272-7-10.5-4.87-6.553,13.981,31.516,14.625,1.642-3.5,4.919-10.484L116.5,246.5,114.859,250l-1.642,3.491,3.5,1.626,1.642-3.5,3.507,1.625-3.286,6.994-3.5-1.618-7-3.261,6.549-13.983,17.5,8.13-18.016,38.455-17.512-8.118,6.549-13.992,10.517,4.87-3.28,7-3.506-1.62,1.639-3.508-3.506-1.623-3.266,7,10.5,4.871,6.547-13.988L87.291,254.235l-6.55,13.98,10.507,4.869,3.279-6.981-3.509-1.629-1.63,3.5-3.508-1.628,3.276-6.988,10.512,4.874-6.555,13.975L75.6,270.085l18.015-38.464,17.51,8.131-6.546,13.99-10.508-4.881,3.275-6.99,3.5,1.621-1.639,3.5Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3418"
              data-name="Path 3418"
              d="M115.988,293.082h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3419"
              data-name="Path 3419"
              d="M68.6,266.83l18.017-38.456L48.1,210.5,30.082,248.953Zm12.879-36.586L66.74,261.711,35.223,247.082,49.96,215.609Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3420"
              data-name="Path 3420"
              d="M64.873,256.58l11.472-24.465L51.827,220.737,40.361,245.211Zm6.333-22.595-8.194,17.483L45.5,243.341l8.191-17.482Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3421"
              data-name="Path 3421"
              d="M61.149,246.349l4.916-10.493-10.51-4.877L50.641,241.47Zm-.231-8.62-1.636,3.492L55.788,239.6l1.63-3.5Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3422"
              data-name="Path 3422"
              d="M49.168,317.407h0l21.3-45.449-.006,0L24.935,250.826h0L4,295.515l.408,1.121,44.757,20.771ZM38.205,295.3l-3.265,7,10.5,4.871,6.547-13.988L20.472,278.56l-6.55,13.98,10.507,4.869,3.278-6.982L24.2,288.8l-1.63,3.5L19.06,290.67l3.277-6.988,10.511,4.874-6.554,13.976L8.783,294.41,26.8,255.946l17.51,8.131-6.546,13.991-10.509-4.882,3.275-6.99,3.5,1.621-1.639,3.5,3.506,1.629,3.271-7-10.5-4.87-6.553,13.981,31.516,14.625,1.642-3.5L60.19,275.7l-10.51-4.878-1.64,3.505L46.4,277.818l3.505,1.626,1.642-3.5,3.508,1.626-3.286,6.994-3.5-1.618-7-3.261,6.55-13.983,17.5,8.13L47.305,312.287l-17.512-8.118,6.549-13.991,10.517,4.869-3.281,7-3.5-1.62,1.639-3.508Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3423"
              data-name="Path 3423"
              d="M49.168,317.407h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3424"
              data-name="Path 3424"
              d="M-17.959,235.175l1.86,5.112,30.762,14.282L.276,285.276,2.14,290.4,19.8,252.7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3425"
              data-name="Path 3425"
              d="M-14.232,245.415l1.864,5.122L4.387,258.31l-7.838,16.724,1.86,5.112L9.525,256.44Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3426"
              data-name="Path 3426"
              d="M-10.5,255.657l1.864,5.122,2.739,1.276-1.28,2.732,1.866,5.128,4.56-9.733Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3427"
              data-name="Path 3427"
              d="M102.9,179.092l-1.823.664,6.829,3.171L89.891,221.382l-17.512-8.118,6.549-13.992,10.517,4.87-3.281,7-3.505-1.62,1.639-3.508-3.506-1.623-3.266,7,10.5,4.871,6.547-13.988L70.232,190.983l-5.143,1.872,10.346,4.8L68.88,211.626l-17.511-8.121,3.194-6.819-5.138,1.87-3.194,6.819.006,0L91.754,226.5h0l20.772-44.319A8.407,8.407,0,0,0,102.9,179.092Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3428"
              data-name="Path 3428"
              d="M97.857,195.278l4.919-10.484-6.832-3.17-5.4,1.964-1.564,3.324,3.5,1.627,1.642-3.5,3.507,1.626-3.286,6.994-3.5-1.619-7-3.261,1.555-3.321-10.029,3.65,20.835,9.669Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3429"
              data-name="Path 3429"
              d="M67.015,206.5l3.278-6.982-3.509-1.628-1.63,3.5-3.508-1.628,3.2-6.821L59.7,194.815l-3.2,6.82Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3430"
              data-name="Path 3430"
              d="M91.755,226.5h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3431"
              data-name="Path 3431"
              d="M.2,230.829l3.278-6.982-3.508-1.628-1.63,3.5-3.508-1.628,3.2-6.826-5.141,1.871-3.2,6.825Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3432"
              data-name="Path 3432"
              d="M24.935,250.826h0l21.3-45.448-.006,0-6.831-3.17-5.147,1.873,6.834,3.174L23.072,245.707,5.56,237.589,12.109,223.6l10.516,4.869-3.28,7-3.5-1.62,1.639-3.508-3.507-1.623-3.265,7,10.5,4.871L27.755,226.6,3.407,215.3l-5.142,1.872,10.35,4.8L2.06,235.952l-17.51-8.122,3.2-6.825-1.8.654a8.4,8.4,0,0,0-5.386,8.576l44.37,20.592Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3433"
              data-name="Path 3433"
              d="M31.038,219.6l4.919-10.484-6.837-3.173-5.389,1.961-1.567,3.33,3.5,1.627,1.642-3.5,3.507,1.626-3.286,6.994-3.5-1.618-7-3.261,1.558-3.326L8.555,213.432,29.4,223.1Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3434"
              data-name="Path 3434"
              d="M24.935,250.827h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3435"
              data-name="Path 3435"
              d="M30.508,368.336l1.86,5.112L63.13,387.73,48.743,418.437l1.863,5.119,17.662-37.7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3436"
              data-name="Path 3436"
              d="M34.235,378.575,36.1,383.7l16.754,7.773-7.838,16.724,1.861,5.112L57.992,389.6Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3437"
              data-name="Path 3437"
              d="M37.962,388.817l1.864,5.122,2.739,1.276-1.28,2.732,1.866,5.128,4.56-9.733Z"
              fill={fillColor || '#8ea5ab'}
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3438)">
            <path
              id="Path_3438-2"
              data-name="Path 3438"
              d="M18.58,193.216c-1.974-11.194,5.6-21.974,20.344-23.222l122.565-21.612c7.73-2.713,18.537,4.825,20.511,16.019l35.887,203.526a20.765,20.765,0,0,1-16.839,23.955L78.483,413.494a20.766,20.766,0,0,1-24.016-16.751Z"
              fill="#fff"
            />
          </g>
          <g id="Group_232" data-name="Group 232">
            <path
              id="Path_3439"
              data-name="Path 3439"
              d="M170.442,372.628l-.015.021.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3440"
              data-name="Path 3440"
              d="M162.307,326.493h0l-.015.021.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3441"
              data-name="Path 3441"
              d="M164.81,340.691l-.015.021.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3442"
              data-name="Path 3442"
              d="M172.945,386.825l-.015.021.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3443"
              data-name="Path 3443"
              d="M154.172,280.359h0l-.015.021.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3444"
              data-name="Path 3444"
              d="M156.676,294.556l-.015.021.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3445"
              data-name="Path 3445"
              d="M146.037,234.224h0l-.015.022.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3446"
              data-name="Path 3446"
              d="M148.541,248.422l-.015.021.021.015Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3447"
              data-name="Path 3447"
              d="M192.791,297.27l-.946-5.365L164.012,272.49l19.512-27.772-.945-5.357L158.624,273.44Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3448"
              data-name="Path 3448"
              d="M190.9,286.528l-.945-5.357-15.17-10.581,10.636-15.131-.947-5.368L169.4,271.54Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3449"
              data-name="Path 3449"
              d="M189.006,275.806l-.948-5.375-2.494-1.742,1.747-2.5-.946-5.368-6.194,8.815Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3450"
              data-name="Path 3450"
              d="M153.23,274.392h0l-28.859,41.067,0,0,41.158,28.707,28.4-40.395-.2-1.128-40.507-28.254Zm6.956,23.686,4.438-6.324-9.5-6.62-8.882,12.63,28.5,19.876,2.225-3.161,6.665-9.47-9.5-6.629-2.224,3.167L169.68,304.7l3.169,2.211,2.224-3.162,3.172,2.21-4.45,6.317-3.168-2.2-6.324-4.427,8.878-12.633,15.826,11.047L164.588,338.8l-15.837-11.036,8.88-12.641,9.511,6.621-4.446,6.325-3.171-2.2,2.223-3.17-3.171-2.207-4.432,6.325,9.5,6.621,8.876-12.638-28.5-19.87-8.878,12.63,9.5,6.62,4.441-6.307-3.173-2.212-2.213,3.162-3.172-2.213,4.44-6.312,9.506,6.625-8.882,12.625-15.834-11.039,24.42-34.751L170.009,290.8l-8.876,12.641-9.5-6.632,4.439-6.315,3.167,2.205-2.221,3.161Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3451"
              data-name="Path 3451"
              d="M205.094,367.047l-.946-5.365-27.833-19.415,19.512-27.772-.945-5.357-23.956,34.079Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3452"
              data-name="Path 3452"
              d="M203.2,356.305l-.945-5.357-15.17-10.581,10.636-15.13-.947-5.369L181.7,341.317Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3453"
              data-name="Path 3453"
              d="M201.31,345.582l-.948-5.374-2.494-1.742,1.747-2.5-.946-5.368-6.194,8.815Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3454"
              data-name="Path 3454"
              d="M123.428,310.087l24.422-34.742L113.018,251.05,88.6,285.792Zm19.037-33.793-19.983,28.428-28.5-19.88,19.979-28.435Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3455"
              data-name="Path 3455"
              d="M121.534,299.345l15.546-22.1-22.17-15.462L99.369,283.893ZM131.7,278.193l-11.106,15.8-15.835-11.044,11.1-15.8Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3456"
              data-name="Path 3456"
              d="M119.643,288.622l6.664-9.479-9.5-6.629-6.661,9.479Zm1.27-8.528-2.217,3.154-3.16-2.206,2.213-3.162Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3457"
              data-name="Path 3457"
              d="M186.43,368.157l-2.224,3.167-2.223,3.152,3.169,2.21,2.225-3.162,3.172,2.21-4.35,6.174,5.391-.951,4.344-6.173Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3458"
              data-name="Path 3458"
              d="M147.445,383.335l6.193,4.315,5.631-.993,2.119-3.009-3.173-2.212L156,384.6l-3.172-2.213,4.439-6.312,9.506,6.625-2.116,3.008,10.52-1.855-18.856-13.146Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3459"
              data-name="Path 3459"
              d="M136.674,385.235l.005,0,6.183,4.313,5.388-.95-6.191-4.316,24.421-34.751,15.833,11.048-8.876,12.641-9.5-6.632,4.439-6.315,3.168,2.2-2.222,3.161,3.17,2.213,4.437-6.324-9.5-6.62-8.881,12.63L180.57,382.9l5.384-.95-3.023-2.1-6.324-4.427,8.877-12.632,15.827,11.046-4.338,6.171,1.922-.339a8.4,8.4,0,0,0,6.792-7.5l-40.153-28.006Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3460"
              data-name="Path 3460"
              d="M124.376,315.461l0,0L83.2,286.744h0L54.828,327.119l.207,1.174,40.471,28.228ZM88.549,332.843l-4.432,6.326,9.5,6.621,8.876-12.639-28.5-19.87-8.878,12.63,9.5,6.62,4.441-6.306-3.173-2.213-2.213,3.162L70.5,324.962l4.44-6.313,9.5,6.626L75.561,337.9,59.728,326.86l24.42-34.751,15.833,11.048L91.105,315.8l-9.5-6.631,4.44-6.315,3.167,2.2-2.222,3.161,3.17,2.213,4.437-6.323-9.5-6.621-8.881,12.631,28.5,19.876,2.225-3.161,6.664-9.471-9.5-6.629-2.224,3.168-2.224,3.152,3.169,2.21,2.225-3.161,3.172,2.209-4.451,6.318-3.167-2.2L94.275,318l8.878-12.633,15.826,11.046L94.56,351.155,78.724,340.12,87.6,327.478l9.512,6.621-4.447,6.325-3.17-2.2,2.223-3.17Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3461"
              data-name="Path 3461"
              d="M135.732,379.864l24.421-34.743-34.831-24.294L100.9,355.569Zm19.037-33.793L134.786,374.5l-28.5-19.879,19.979-28.435Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3462"
              data-name="Path 3462"
              d="M133.837,369.122l15.546-22.1-22.169-15.462L111.673,353.67ZM144,347.97l-11.1,15.8L117.058,352.72l11.1-15.794Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3463"
              data-name="Path 3463"
              d="M131.947,358.4l6.663-9.479-9.5-6.629-6.661,9.479Zm1.269-8.528L131,353.025l-3.159-2.206,2.213-3.162Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3464"
              data-name="Path 3464"
              d="M43.678,263.882l.945,5.357,27.815,19.407-19.5,27.742.946,5.365L77.822,287.7Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3465"
              data-name="Path 3465"
              d="M45.57,274.613l.947,5.368,15.15,10.564L51.043,305.654l.945,5.357L67.051,289.6Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3466"
              data-name="Path 3466"
              d="M47.462,285.347l.946,5.368,2.476,1.732-1.735,2.468.948,5.374,6.181-8.793Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3467"
              data-name="Path 3467"
              d="M136.674,385.235,95.506,356.521,67.377,396.547a8.406,8.406,0,0,0,8.953,4.735l1.886-.333-6.185-4.311,24.421-34.752,15.832,11.048-8.876,12.641-9.5-6.631,4.439-6.316,3.168,2.205-2.222,3.161,3.17,2.213,4.437-6.323-9.5-6.621-8.881,12.631,22.017,15.356,5.385-.949-3.019-2.1-6.323-4.426,8.877-12.633,15.826,11.046-4.334,6.167,5.4-.952,4.336-6.167Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3468"
              data-name="Path 3468"
              d="M77.416,395.688,83.6,400l5.64-.994,2.115-3-3.172-2.213-2.213,3.162L82.8,394.738l4.44-6.312,9.506,6.626-2.113,3,10.511-1.853L86.294,383.058Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3469"
              data-name="Path 3469"
              d="M116.4,380.51l-2.224,3.167-2.224,3.153,3.169,2.21,2.225-3.161,3.172,2.21-4.346,6.169,5.391-.951,4.34-6.168Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3470"
              data-name="Path 3470"
              d="M180.487,227.494l-.946-5.365-27.833-19.415,19.512-27.772-.945-5.357-23.956,34.079Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3471"
              data-name="Path 3471"
              d="M178.593,216.752l-.945-5.357-15.17-10.581,10.636-15.131-.947-5.369-15.075,21.449Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3472"
              data-name="Path 3472"
              d="M176.7,206.029l-.948-5.374-2.494-1.741,1.747-2.5-.946-5.368-6.194,8.815Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3473"
              data-name="Path 3473"
              d="M140.927,204.615h0l-28.86,41.066,0,0,41.158,28.706h0L181.634,234l-.2-1.128-40.508-28.253Zm6.956,23.686,4.437-6.323-9.5-6.621-8.881,12.631,28.5,19.876,2.225-3.162,6.665-9.47-9.5-6.628L159.6,231.77l-2.224,3.153,3.169,2.21,2.225-3.161,3.172,2.21-4.451,6.317-3.167-2.2L152,235.871l8.877-12.633L176.7,234.284l-24.42,34.742-15.836-11.035,8.879-12.642,9.511,6.621-4.446,6.325-3.171-2.2,2.224-3.17-3.172-2.207-4.431,6.326,9.5,6.621,8.877-12.639-28.5-19.87-8.878,12.63,9.5,6.62,4.441-6.306-3.172-2.213-2.213,3.162-3.172-2.213,4.439-6.312,9.506,6.626-8.882,12.624-15.834-11.038,24.421-34.752,15.832,11.048-8.876,12.641-9.5-6.631,4.439-6.316,3.168,2.205-2.222,3.161Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3474"
              data-name="Path 3474"
              d="M153.231,274.391h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3475"
              data-name="Path 3475"
              d="M111.125,240.31l24.421-34.742-34.831-24.295L76.292,216.016Zm19.037-33.793-19.983,28.428-28.5-19.879,19.979-28.436Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3476"
              data-name="Path 3476"
              d="M109.23,229.568l15.546-22.1L102.607,192,87.066,214.116Zm10.161-21.152-11.1,15.795L92.451,213.167l11.1-15.8Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3477"
              data-name="Path 3477"
              d="M107.34,218.846l6.663-9.48-9.5-6.628-6.661,9.478Zm1.269-8.529-2.217,3.154-3.159-2.206,2.213-3.162Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3478"
              data-name="Path 3478"
              d="M83.2,286.744h0l28.87-41.059,0,0L70.9,216.967h0L42.525,257.342l.207,1.175L83.2,286.744Zm-6.957-23.678-4.431,6.326,9.5,6.621,8.876-12.639-28.5-19.87-8.878,12.63,9.5,6.62,4.441-6.306-3.172-2.213L61.367,257.4l-3.173-2.212,4.44-6.312L72.14,255.5l-8.882,12.625L47.424,257.084l24.421-34.751L87.677,233.38,78.8,246.022l-9.5-6.632,4.439-6.315,3.168,2.205-2.222,3.16,3.17,2.214,4.437-6.324-9.5-6.62-8.881,12.63,28.5,19.876,2.225-3.161,6.665-9.47-9.5-6.629-2.224,3.167-2.223,3.152,3.169,2.211,2.225-3.162,3.172,2.21-4.451,6.317-3.168-2.2-6.324-4.426,8.878-12.633,15.826,11.046L82.256,281.378,66.42,270.343,75.3,257.7l9.511,6.621-4.446,6.326-3.171-2.2,2.223-3.171Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3479"
              data-name="Path 3479"
              d="M83.2,286.744h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3480"
              data-name="Path 3480"
              d="M31.374,194.105l.945,5.357L60.133,218.87l-19.5,27.742.946,5.365,23.94-34.056Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3481"
              data-name="Path 3481"
              d="M33.266,204.836l.947,5.368,15.15,10.564L38.74,235.878l.945,5.357,15.064-21.415Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3482"
              data-name="Path 3482"
              d="M35.159,215.57l.946,5.368,2.476,1.732-1.735,2.468.948,5.374,6.181-8.793Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3483"
              data-name="Path 3483"
              d="M160.137,159.861l-1.911.337,6.174,4.309-24.419,34.742-15.837-11.035,8.88-12.642,9.511,6.621-4.446,6.325-3.171-2.2,2.223-3.169-3.171-2.208-4.432,6.326,9.5,6.621,8.876-12.639L125.9,165.9l-5.389.951,9.355,6.52-8.882,12.624-15.834-11.038,4.329-6.161-5.385.949L99.764,175.9l0,0,41.158,28.707h0l28.152-40.039A8.4,8.4,0,0,0,160.137,159.861Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3484"
              data-name="Path 3484"
              d="M152.359,174.926l6.665-9.47-6.177-4.308-5.656,1-2.117,3,3.169,2.21,2.225-3.161,3.172,2.21-4.451,6.317-3.167-2.2-6.324-4.426,2.108-3-10.51,1.853,18.84,13.14Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3485"
              data-name="Path 3485"
              d="M120.036,180.625l4.441-6.306-3.173-2.213-2.213,3.162-3.172-2.213,4.334-6.162-5.388.95-4.331,6.161Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3486"
              data-name="Path 3486"
              d="M140.927,204.615h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3487"
              data-name="Path 3487"
              d="M50.008,192.978l4.441-6.306-3.172-2.213-2.213,3.162-3.172-2.213,4.338-6.167-5.388.95-4.335,6.166Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3488"
              data-name="Path 3488"
              d="M70.9,216.967h0l28.87-41.059,0,0L93.586,171.6l-5.393.951,6.179,4.313L69.953,211.6,54.116,200.566,63,187.925l9.511,6.621-4.447,6.325-3.17-2.2,2.223-3.17-3.171-2.207-4.432,6.325,9.5,6.621L77.883,193.6,55.866,178.247l-5.39.951,9.36,6.523-8.882,12.625L35.121,187.307l4.333-6.166-1.882.332a8.4,8.4,0,0,0-6.794,7.511L70.9,216.967Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3489"
              data-name="Path 3489"
              d="M82.331,187.278,89,177.808,82.813,173.5l-5.647,1L75.044,177.5l3.169,2.21,2.225-3.162,3.172,2.21-4.451,6.317-3.168-2.2-6.324-4.426,2.112-3.005L61.261,177.3,80.106,190.44Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3490"
              data-name="Path 3490"
              d="M70.9,216.967h0Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3491"
              data-name="Path 3491"
              d="M55.981,333.659l.945,5.357L84.74,358.423l-19.5,27.742.946,5.365,23.94-34.056Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3492"
              data-name="Path 3492"
              d="M57.873,344.39l.947,5.368,15.15,10.564L63.347,375.431l.945,5.357,15.064-21.415Z"
              fill={fillColor || '#8ea5ab'}
            />
            <path
              id="Path_3493"
              data-name="Path 3493"
              d="M59.766,355.124l.946,5.368,2.476,1.732-1.735,2.468.948,5.374,6.181-8.793Z"
              fill={fillColor || '#8ea5ab'}
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3494)">
            <path
              id="Path_3494-2"
              data-name="Path 3494"
              d="M69,154.477A22.775,22.775,0,0,1,91.75,131.81h136.5A22.776,22.776,0,0,1,251,154.477V381.144a22.775,22.775,0,0,1-22.75,22.666H91.75A22.775,22.775,0,0,1,69,381.144Z"
              fill="#fff"
            />
          </g>
          <path
            id="Path_3495"
            data-name="Path 3495"
            d="M91.75,140.31A14.226,14.226,0,0,0,77.5,154.477V381.144A14.225,14.225,0,0,0,91.75,395.31h136.5a14.225,14.225,0,0,0,14.25-14.166V154.477a14.226,14.226,0,0,0-14.25-14.167Z"
            fill="none"
            stroke="#d9000d"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <path
            id="Path_3496"
            data-name="Path 3496"
            d="M196.07,160.338a8.868,8.868,0,0,1,16.945-3.661,8.869,8.869,0,0,1,16.946,3.661h0c0,.013,1.292,9.172-16.887,20.962l-.048.032-.049-.032c-16.478-10.687-16.96-19.213-16.9-20.723C196.071,160.5,196.07,160.418,196.07,160.338Z"
            fill="#dc091d"
          />
          <path
            id="Path_3497"
            data-name="Path 3497"
            d="M123.93,375.282a8.869,8.869,0,0,1-16.946,3.662,8.868,8.868,0,0,1-16.945-3.662h0c0-.012-1.292-9.172,16.887-20.962l.048-.031.049.031c16.478,10.688,16.959,19.214,16.9,20.724C123.929,375.123,123.93,375.2,123.93,375.282Z"
            fill="#dc091d"
          />
        </g>
      </g>
    </svg>
  );
}
export default CardGroup1;
